import { CommonModule } from '@angular/common';
import { Component, forwardRef, Input } from '@angular/core';
import { FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { BaseControlComponent } from '@avenir-client-web/base-control';
import { MultiSelectModule as PMultiSelectModule } from 'primeng/multiselect';

@Component({
  selector: 'app-multi-select',
  templateUrl: './multi-select.component.html',
  styleUrls: ['./multi-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MultiSelectComponent),
      multi: true,
    },
  ],
  imports: [CommonModule, PMultiSelectModule, FormsModule],
})
export class MultiSelectComponent extends BaseControlComponent {
  @Input() styleClass: string;

  @Input() options: unknown[];

  @Input() optionLabel: string;

  @Input() optionValue: string;

  @Input() virtualScroll = false;
}
